import { useTranslation } from "react-i18next";
import { useNavbarDisplayMode } from "../../../../../hooks/useNavbarDisplayMode";

export default function NavBarDisplayModeSelector() {
	const { Icon, label, toggle } = useNavbarDisplayMode();
	const { t } = useTranslation();

	return (
		<div className="flex justify-between items-center flex-col xs:flex-row gap-[0.1rem] xs:gap-0 whitespace-nowrap w-full">
			<p className="m-0 leading-none">{t("navBarItems.toolsMenu.navBar.title")}</p>

			<button className="flex flex-row justify-center items-center cursor-pointer" onClick={toggle}>
				<span className="text-[80%] uppercase font-semibold leading-none">{label}</span>&nbsp;
				<Icon />
			</button>
		</div>
	);
}